import styled from 'styled-components';
import { Link } from '@/shared/ui/link';
import { BodyTextRegularB } from '@/shared/ui/typography2';
import { useScopedI18n } from '@locales/client';
import { Line, TitleContainer } from '@/shared/ui/footer/styles';

const HREF_DATA = [
  { href: '/games', titleKey: 'category_casino' },
  { href: '/betting', titleKey: 'category_betting' },
  { href: '/status', titleKey: 'category_status' },
  { href: '/cashback', titleKey: 'category_cashback' },
];

export const CategoryBlock = () => {
  const t = useScopedI18n('common.footer');

  return (
    <BlockWrapper>
      <TitleContainer>
        <BodyTextRegularB color="#AFAFAF">
          {t('category_title').toUpperCase()}
        </BodyTextRegularB>
        <Line $hideOnMobile />
      </TitleContainer>

      <Content>
        {HREF_DATA.map(({ href, titleKey }) => (
          <Link key={href} href={href}>
            <BodyTextRegularB color="#FFF">{t(titleKey)}</BodyTextRegularB>
          </Link>
        ))}
      </Content>
    </BlockWrapper>
  );
};

const BlockWrapper = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 12px;
`;
const Content = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr;
  gap: 12px;
  @media screen and (min-width: 641px) {
    grid-template-columns: repeat(4, 1fr);
    grid-template-rows: 1fr;
  }
  @media screen and (min-width: 841px) {
    grid-template-columns: 1fr;
    grid-template-rows: repeat(4, 1fr);
  }
`;
